<div class="d-flex flex-column w-100 w-sm-60 mx-auto">
  <div class="d-flex flex-wrap flex-sm-nowrap container gap-3">
    <div class="d-flex flex-column col-12 col-sm-6">
      <app-ashgrid-appellation class="mb-0"></app-ashgrid-appellation>

      <div class="d-flex mt-5">
        <p class="ms-2 my-auto fw-normal" style="font-size: 56px; line-height: normal;">Email Verification</p>
      </div>
    </div>

    <div class="d-flex flex-column col-12 col-sm-6 mt-3 mt-sm-0 mxw-420px">
      <div class="d-flex mx-auto p-2e">
        <p class="mb-auto mat-headline-5 fw-bold">Email Verified! You are set</p>
      </div>

      <div class="d-flex flex-column w-100 py-5">
        <app-email-verification-complete-vector class="mx-auto"></app-email-verification-complete-vector>

        <!-- INFO Click the verification link in the mail we sent you to complete your account creation -->
        <div class="d-flex mx-auto mt-5 p-2e">
          <p class="mb-auto mat-body-1 text-center">Success! Your email has been verified. You can now log in and continue with your onboarding.</p>
        </div>

        <button mat-flat-button class="my-4 px-3 py-4 fw-bold rounded-3e" color="primary" (click)="goToLogin()">
          <span class="my-auto mat-body-1 fw-bold">Continue to Login</span>
        </button>
      </div>
    </div>
  </div>
</div>
